import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const ShowMoreIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5931 0.666748C3.9931 0.666748 0.259766 4.40008 0.259766 9.00008C0.259766 13.6001 3.9931 17.3334 8.5931 17.3334C13.1931 17.3334 16.9264 13.6001 16.9264 9.00008C16.9264 4.40008 13.1931 0.666748 8.5931 0.666748ZM11.7514 8.75842L9.18477 11.3251C8.85977 11.6501 8.33477 11.6501 8.00143 11.3251L5.43477 8.75842C5.10977 8.43341 5.10977 7.90008 5.43477 7.57508C5.75977 7.25008 6.28477 7.25008 6.60977 7.57508L8.5931 9.55842L10.5764 7.57508C10.9014 7.25008 11.4264 7.25008 11.7514 7.57508C12.0764 7.90008 12.0764 8.43341 11.7514 8.75842Z"
        fill="black"
        fill-opacity="0.56"
      />
    </StyledSVGIcon>
  );
};
